export enum Type {
  WIZARD_LAST_USED_STYLE_SET = 'app/wizard-last-used-style/WIZARD_LAST_USED_STYLE_SET',

  WIZARD_LAST_USED_STYLE_AUDIOGRAM_RESET = 'app/wizard-last-used-style/WIZARD_LAST_USED_STYLE_AUDIOGRAM_RESET',
  WIZARD_LAST_USED_STYLE_FULL_EPISODE_RESET = 'app/wizard-last-used-style/WIZARD_LAST_USED_STYLE_FULL_EPISODE_RESET',
  WIZARD_LAST_USED_STYLE_AUTOGRAM_RESET = 'app/wizard-last-used-style/WIZARD_LAST_USED_STYLE_AUTOGRAM_RESET',
  WIZARD_LAST_USED_STYLE_VIDEO_TRANSCRIPTION_RESET = 'app/wizard-last-used-style/WIZARD_LAST_USED_STYLE_VIDEO_TRANSCRIPTION_RESET',
}
